import { apiGet, apiPost } from "api/callApi";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import theme from "theme";
import { Loader } from "..";
import { formatFileSize } from "utils/helper";

const ExportProject = () => {
  const [hover, setHover] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [data, setData] = useState();
  const [searchParams] = useSearchParams();
  const [disabled, setDisabled] = useState(false);
  const token = searchParams.get("token");

  const getDownloadURl = async () => {
    try {
      setLoading(true);
      const response = await apiGet(
        `/v1/projects/exportfullproject?token=${token}`
      );


      if (response?.data) {
        setData(response.data);
      }
      setLoading(false);
    } catch (err) {
      setError("Something went wrong during download ❌");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDownloadURl();
  }, [token]);

  const handleDownload = async () => {
    if (data?.fileURI) {
      const response = await apiPost(`/v1/projects/dowloadurl`, {
        fileURI: data?.fileURI,
      });
      setDisabled(true);
      if (response?.downloadUrl) {
        window.open(response.downloadUrl);
      }
      if (response?.data) {
        setData(response.data);
      }
    }
  };

  const cardStyle = {
    fontFamily: "Segoe UI, sans-serif",
    color: "#333",
    backgroundColor: "#fff",
    maxWidth: "600px",
    margin: "50px auto",
    padding: "32px",
    borderRadius: "14px",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)",
    border: "1px solid #f0f0f0",
    textAlign: "center",
  };

  const buttonStyle = {
    display: "inline-block",
    backgroundColor: theme.colors.themeColor,
    color: "#fff",
    padding: "12px 24px",
    fontSize: "16px",
    borderRadius: "8px",
    marginTop: "20px",
    cursor: "pointer",
    border: "none",
    transition: "opacity 0.3s ease, background-color 0.3s ease",
  };

  const disabledButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#ccc",
    opacity: 0.6,
    cursor: "not-allowed",
  };

  if (loading) return <Loader />;

  if (error) {
    return (
      <div style={cardStyle}>
        <h2 style={{ fontSize: "22px", color: "#d32f2f" }}>⚠️ Link Expired</h2>
      </div>
    );
  }

  return (
    <div style={cardStyle}>
      <h2 style={{ fontSize: "24px", marginBottom: "12px" }}>
        Your Project Export is Ready 🎉
      </h2>
      <p style={{ marginBottom: "12px", fontSize: "16px" }}>
        The <strong>{data?.propertyName}</strong> project is ready for download.
      </p>
      <p style={{ fontSize: "14px", marginBottom: "16px", color: "#555" }}>
        <strong>File:</strong> {data?.fileName}
        <br />
        <strong>Size:</strong> {formatFileSize(data?.fileSize)}
      </p>

      <p style={{ fontSize: "14px", color: "#666" }}>
        Click below to download your ZIP file
      </p>

      <button
        style={disabled ? disabledButtonStyle : buttonStyle}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={handleDownload}
        disabled={disabled}
      >
        {"Download Now"}
      </button>

      {message && (
        <p style={{ color: "#2e7d32", marginTop: "16px" }}>{message}</p>
      )}
      {error && <p style={{ color: "#d32f2f", marginTop: "16px" }}>{error}</p>}

      {/* <p style={{ marginTop: "20px", fontSize: "13px", color: "#888" }}>
        This link will expire on closing of tab. Please download the file.
      </p> */}
    </div>
  );
};

export default ExportProject;
